export const AUDIT_LOGS_ROUTES = {
    __ROOT__: '/auditLogs',
}
